import { isEmpty } from 'lodash/fp';
import { type } from '@mews-framework/utils';
import { DateTimeUtcService } from '../dateTimesUtc';

export default function AppClockComponent({ getServerNowUtc, context }: $TSFixMe) {
    return type.create(AppClockComponent, {
        getAppNowUtc() {
            return DateTimeUtcService.fromEpoch(getValue());
        },
        getValue,
    });

    function getValue() {
        const serverNowUtc = getServerNowUtc();

        if (!context.performance || !context.performance.now || isEmpty(serverNowUtc)) {
            return Date.now();
        }

        const dateTimeUtc = DateTimeUtcService.parse(serverNowUtc);

        return DateTimeUtcService.getEpoch(dateTimeUtc) + context.performance.now();
    }
}
